import React from 'react';
import './ContactPage.css';
import { useTranslation } from '../hooks/useTranslation';

const ContactPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="page-container-narrow">
      <h1 className="page-title">{t('contact.title')}</h1>
      
      <div className="contact-content">
        <p className="contact-intro">
          {t('contact.intro')}
        </p>

        <div className="contact-grid">
          <div className="contact-info">
            <div className="contact-item">
              <h3>{t('contact.email')}</h3>
              <a href="mailto:seaingyou@outlook.com" className="contact-link">
                seaingyou@outlook.com
              </a>
            </div>

            <div className="contact-item">
              <h3>{t('contact.phone')}</h3>
              <a href="tel:+31640935823" className="contact-link">
                +31 6 4093 5823
              </a>
            </div>

            <div className="contact-item">
              <h3>{t('contact.wechat')}</h3>
              <p className="contact-description">
                {t('contact.wechatDescription')}
              </p>
            </div>
          </div>

          <div className="wechat-qr-container">
            <img 
              src="/images/wechat.png" 
              alt={t('contact.wechatQrAlt')}
              className="wechat-qr-image"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
